<template>
  <div class="row reverse-mobile justify-content-center">
    <AdminMenu></AdminMenu>

    <div class="col-12 col-md-9 center-content">
      <CommunityCard class="p-4">
        <form
          @submit.prevent="updateSearchTerm"
          class="mb-3 col-12 align-items-center input-group d-flex"
        >
          <input
            type="text"
            class="form-control"
            placeholder="Search all users"
            aria-label="Search for"
            aria-describedby="basic-addon2"
            id="userSeachTerm"
          />
          <div class="input-group-append">
            <button
              id="userSearchButton"
              class="d-flex align-items-center btn btn-primary"
              type="submit"
            >
              <i class="material-icons p-0" style="margin-right: 7px">search</i
              >Search
            </button>
          </div>
        </form>

        <PleaseWait
          v-if="is_loading"
          bg-colour="#ffffff"
          class="m-4 w-100 d-flex flex-column justify-content-center align-items-center small-full"
        />

        <div
          class="w-75 d-flex flex-column justify-content-center align-items-center small-full"
          v-if="userCount == 0 && !is_loading"
        >
          <NoResults></NoResults>
        </div>

        <div
          v-if="userCount > 0 && !is_loading"
          class="col-sm scenario-scroll-page"
        >
          <div class="row d-flex justify-content-end mr-4">
            <div v-if="userCount > 0 && !is_loading" class="results-count">
              <b class="deep">({{ userCount }})</b>
              User{{ userCount != 1 ? "s" : "" }} available
            </div>
          </div>
          <div
            v-if="userCount > 0"
            class="pagination-wrapper col-12 d-flex justify-content-end mt-3 mr-5"
          >
            <template>
              <paginate
                v-model="page"
                :page-count="pageCount"
                :page-range="3"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'"
              ></paginate>
            </template>
          </div>
          <div>
            <ul style="list-style-type: none; padding-left: 0px">
              <li v-for="user in users" v-bind:key="user.id">
                <UserCard
                  v-on:toggle-enabled="toggleEnabled(user)"
                  :user="user"
                  :includeActions="true"
                />
              </li>
            </ul>
          </div>
          <div
            v-if="userCount > 0"
            class="pagination-wrapper col-12 d-flex justify-content-end mt-3 mr-5"
          >
            <template>
              <paginate
                v-model="page"
                :page-count="pageCount"
                :page-range="3"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'"
              ></paginate>
            </template>
          </div>
        </div>
      </CommunityCard>
    </div>
  </div>
</template>

<script>
import UserService from "@/services/user.service";
import Paginate from "@/components/Paginate";
import PleaseWait from "@/components/PleaseWait";
import NoResults from "@/components/NoResults";
import AdminMenu from "@/components/AdminMenu";
import UserCard from "@/components/UserCard";
import CommunityCard from "@/components/CommunityCard";

export default {
  name: "UsersAdmin",
  components: {
    CommunityCard,
    Paginate,
    PleaseWait,
    NoResults,
    AdminMenu,
    UserCard,
  },
  data: function () {
    return {
      is_loading: true,
      users: [],
      userCount: 0,
      NUMBER_TO_GET: 100,
      pageCount: 0,
      page: 0,
      from: 0,
      to: 0,
      searchTerm: -1,
      pageNum: 0,
    };
  },
  methods: {
    getUsers(startAt) {
      this.is_loading = true;
      if (!this.searchTerm) {
        this.searchTerm = -1;
      }

      UserService.getAll(startAt, this.NUMBER_TO_GET, this.searchTerm)
        .then((data) => {
          this.users = data.users;
          this.userCount = data.total;
          this.from = parseInt(data.from);
          this.to = parseInt(data.to);
          this.updatePageCount();
          this.is_loading = false;
        })
        .catch((error) => {
          if (error.message.includes("404")) {
            this.component404 = true;
          }
        });
    },

    clickCallback: function (pageNum) {
      this.isActive = true;

      window.scrollTo(0, 0);
      this.page = pageNum;
      pageNum = pageNum - 1;
      this.users = [];
      this.getUsers(this.NUMBER_TO_GET * pageNum);
    },

    updatePageCount() {
      this.pageCount = Math.ceil(this.userCount / this.NUMBER_TO_GET);
    },

    updateSearchTerm() {
      this.searchTerm = document
        .getElementById("userSeachTerm")
        .value.toLowerCase();
      this.getUsers();
    },

    toggleEnabled(user) {
      UserService.setEnabled(user.uuid_id, !user.enabled).then((data) => {
        user.enabled = data.enabled;
      });
    },
  },
  mounted() {
    this.is_loading = true;
    this.getUsers(0);
  },
};
</script>

<style>
.results-count {
  color: var(--isim-light-text);
  font-size: 14px;
  text-align: center;
}
</style>
